"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuGroupContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useMenuGroupContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useMenuGroupContextValues_unstable(state) {
    const { headerId } = state;
    const menuGroup = _react.useMemo(()=>({
            headerId
        }), [
        headerId
    ]);
    return {
        menuGroup
    };
}
